export class FileNotConvertableException extends Error {}
